// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"94db65e5","453":"321fab51"}[chunkId] + ".chunk.js";
};